function CheckClassName() {
  let isModalOpen = false
  const isModelClassPresent = document.body.classList.contains('modal-open')

  if (isModelClassPresent) {
    isModalOpen = true
  }
  const selectZIndex = isModalOpen ? 1060 : 1000
  return selectZIndex
}

export const customStyles = {
  menuPortal: (provided) => ({
    ...provided,
    zIndex: CheckClassName(),
    scrollbarWidth: '0px'
  }),
  // menu: (provided) => ({ ...provided, zIndex: 9999, maxHeight:'150px', overflowY: 'auto' })
  // menu: (provided) => ({
  //   ...provided,
  //   zIndex: 10000,
  //   position: 'relative',
  // }),
  // option: (provided, state) => ({
  //   ...provided,
  //   backgroundColor: state.isSelected ? '#eee' : 'white',
  //   color: state.isSelected ? 'white' : 'black',
  //   scrollbarWidth:"opx"
  // }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '150px',
    overflowY: 'auto',
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0.5em'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'lightgray',
      borderRadius: '4px'
    }
  })
}
